import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideMail = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
      <rect width={20} height={16} x={2} y={4} rx={2} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideMail);
const Memo = memo(ForwardRef);
export default Memo;
